import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Camera, AlertTriangle, RefreshCw, FileBarChart2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';

function QuickActions({ onRefresh }) {
  const navigate = useNavigate();

  const actions = [
    { label: 'View Screenshots', Icon: Camera, path: '/screenshots' },
    { label: 'View Incidents', Icon: AlertTriangle, path: '/incidents' },
    { label: 'Generate Report', Icon: FileBarChart2, path: '/reports' },
    { label: 'Refresh Data', Icon: RefreshCw, onClick: onRefresh },
  ];

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base">Quick Actions</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-2">
          {actions.map((action) => {
            const Icon = action.Icon;
            return (
              <Button
                key={action.label}
                variant="outline"
                className="justify-start"
                onClick={action.onClick || (() => navigate(action.path))}
              >
                <Icon />
                {action.label}
              </Button>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}

export default QuickActions;
